<template>
  <div class="">
    <el-table :data="pagingList"
              :header-cell-style="headerCellStyle"
              class="custom-delivery-table"
              max-height="600px"
              size="small"
              border>
      <el-table-column label="仓库" min-width="200" prop="warehousecode"/>
      <el-table-column label="区域" width="160" prop="">
        <template slot-scope="scope">
          {{ regionName(scope.row.region) }}
        </template>
      </el-table-column>
      <el-table-column label="目的城市" width="160" prop="cityName"/>
      <el-table-column label="费用" width="180" prop="">
        <template slot-scope="scope">
          <price-blurring
            class="color-primary"
            :price-display-type="scope.row.priceDisplayType"
            :currency="scope.row.currency"
            :price="scope.row.priceinfo"
          />
        </template>
      </el-table-column>
      <el-table-column label="预估整体时效" width="140" prop="aging"/>
      <el-table-column label="船期" width="140" prop="shippingDateInformation"/>
      <el-table-column label="报价链接" width="100">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" @click="clickItem(scope.row)">点击查价</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="list && list.length>pageSize"
      class="paging-row"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="totalListNum"
      background
    >
    </el-pagination>
  </div>
</template>

<script>

import {isArray} from "my-tools-kit";
import PriceBlurring from "../../../../../common/priceBlurring";

export let headerCellStyle = { background: '#F3F3F3', color: '#999999' };
export default {
  name: "homeHotRecommendWarehouseProductList",
  components: {PriceBlurring},
  props:{
    list:{
      type:Array,
      required:true,
      default:()=>[],
    },
  },
  data(){
    return {
      headerCellStyle,
      /* 分页参数 */
      pageSizes: [12,20,30,40,50],
      pageSize: 999,
      currentPage: 1,
    }
  },
  computed:{
    pagingList(){
      let list = this.list;
      if(!isArray(list) || !list.length) return [];
      let start = this.pageSize * (this.currentPage - 1);
      let end = this.pageSize * this.currentPage;
      return list.slice(start,end);
    },
    totalListNum(){
      let list = this.list||[];
      return list.length
    },
  },
  watch:{
    list(){
      this.handleCurrentChange();
    },
  },
  methods:{
    /**
     * pageSize 改变时会触发：选择每页显示条数
     */
    handleSizeChange(val, type) {
      this.pageSize = val;
      this.handleCurrentChange();
    },
    /**
     * currentPage 改变时会触发：选择页数
     */
    handleCurrentChange(val = 1, type) {
      this.currentPage = val;
    },
    regionName(region){
      let m = {
        1:"美东",
        2:"美中",
        3:"美西",
      };
      return m[region]||"其他";
    },
    clickItem(item){
      this.$emit("clickItem",item);
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeHotRecommend/homeHotRecommendWarehouseProductList.vue